// extracted by mini-css-extract-plugin
export var container = "_4a-0";
export var containerTopRight = "_4a-1";